import "./src/styles/global.css";
import "./src/styles/global.css";
export const onInitialClientRender = () => {
  document.addEventListener("contextmenu", (event) => event.preventDefault());
}; //DISABLE RIGHT CLICK
